import { gql } from 'graphql-request';

import {
  AccountID,
  AccountUUID,
  AccountNanoID,
  AccountCreatedAt,
  AccountGeneralLedgerId,
  AccountIncreaseSide,
  AccountBalance,
  AccountAccountTypeUUID,
  AccountAccountTypeNanoID,
  AccountAccountTypeCreatedAt,
  AccountAccountTypeName,
  AccountAccountTypeClientName,
  AccountAccountTypePerformerName,
  AccountAccountTypeShortName,
  AccountAccountTypeSystemName,
  AccountAccountTypeChartNumber,
  AccountAccountTypeIncreaseSides,
  AccountLastJournalRecordID,
  AccountLastJournalRecordAmount,
  AccountLastJournalRecordSide,
  AccountLastJournalRecordCreatedAt
} from '../accountsTypes';

export interface FetchCacheAccountsQueryResponse {
  id: AccountID;
  uuid: AccountUUID;
  nanoId: AccountNanoID;
  createdAt: AccountCreatedAt;
  generalLedgerId: AccountGeneralLedgerId;
  increaseSide: AccountIncreaseSide;
  balance: AccountBalance;
  accountType: {
    uuid: AccountAccountTypeUUID;
    nanoId: AccountAccountTypeNanoID;
    createdAt: AccountAccountTypeCreatedAt;
    name: AccountAccountTypeName;
    clientName: AccountAccountTypeClientName;
    performerName: AccountAccountTypePerformerName;
    shortName: AccountAccountTypeShortName;
    systemName: AccountAccountTypeSystemName;
    chartNumber: AccountAccountTypeChartNumber;
    increaseSide: AccountAccountTypeIncreaseSides;
  };
  lastJournalRecord: {
    id: AccountLastJournalRecordID;
    amount: AccountLastJournalRecordAmount;
    side: AccountLastJournalRecordSide;
    createdAt: AccountLastJournalRecordCreatedAt;
  };
}

export const FETCH_CACHE_ACCOUNTS_QUERY = gql`
  query CacheAccounts(
    $filters: AccountsFilters
    $sort: [AccountsSortEnum]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    accounts(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        accountType {
          chartNumber
          createdAt
          increaseSide
          name
          clientName
          performerName
          shortName
          nanoId
          systemName
          uuid
        }
        balance
        createdAt
        generalLedgerId
        id
        increaseSide
        nanoId
        uuid
        lastJournalRecord {
          id
          amount
          side
          createdAt
        }
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
